import { helper } from '@ember/component/helper';
import { ButtonDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
function getButtonVariant([buttonVariant]) {
  switch (buttonVariant) {
    case ButtonDescription.ButtonVariant.BUTTON_VARIANT_DESTRUCTIVE:
      return 'destructive';
    case ButtonDescription.ButtonVariant.BUTTON_VARIANT_NORMAL:
      return 'regular';
    default:
      return '';
  }
}
export default helper(getButtonVariant);